const INITIAL_STATE = {
  setores: {
    data: []
  },
  setor: null,
  hierarquias: [],
  setorFiltro: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SETORES_FETCHED':
      return { ...state, setores: action.payload }
    case 'SETOR_FETCHED':
      return { ...state, setor: action.payload }
    case 'HIERARQUIA_FETCHED':
      return { ...state, hierarquias: action.payload }
    case 'SETOR_FILTRO':
      return { ...state, setorFiltro: action.payload }
    default:
      return state
  }
}